<template>
  <div>
    <div class="user-info-header">
      <div>
        <div class="user-info-hello-title">Olá, <span class="primary">{{userInfo.Nome}}</span></div>
        <div class="user-info-hello-subtitle">Este é o resumo do seu pedido</div>
      </div>
      <div>
        <Asset
          name="logo.svg"
          alt="Logo Parcelex"
          title="Logo Parcelex"
          id="checkout-header-logo"
        />
      </div>
    </div>
    <div class="user-info-list" v-if="!isMobile()">
      <div class="user-info-item" v-for="(infoKey, i) in Object.keys(userInfo)" :key="i">
        <div class="user-info-item-key">{{infoKey}}</div>
        <div class="user-info-item-value">{{userInfo[infoKey]}}</div>
      </div>
    </div>
    <div v-else>
      <GenericSummaryList
      :data="userInfo"
      :buttonText="buttonText"
      event="updateData"
      @updateData="actionEvent"
      :title="'Dados de cadastro'"/>
    </div>
  </div>
</template>

<script>
import UtilMixin from '@/mixins/util';
import Asset from '@/components/common/Asset.vue';
import GenericSummaryList from './GenericSummaryList.vue';

export default {
  name: 'checkout-user-info-display',
  mixins: [UtilMixin],
  components: {
    GenericSummaryList,
    Asset,
  },
  props: {
    userInfo: {
      type: Object,
    },
    buttonText: {
      type: String,
      default: null,
    },
  },
  methods: {
    actionEvent(value) {
      this.$emit('updateData', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: $md) {
    flex-direction: column-reverse;
    justify-content: start;

    & img {
      padding-bottom: 16px;
    }
  }
}
.user-info-hello-title {
  @extend .h2;
  @extend .gray-600;
}

.user-info-hello-subtitle {
  @extend .body-regular;
  @extend .gray-400;
}

.user-info-list {
  padding: 8px 0;
  display: flex;
  flex-wrap: wrap;
}

.user-info-item {
  padding: 8px 0;
  flex: 0 50%;
}

.user-info-item-key {
  @extend .small-regular;
  @extend .gray-600;
}

.user-info-item-value {
  @extend .body-bold;
  @extend .gray-600;
}

</style>
